// @flow
import Store from './store';
import action from './action-decorator';
import AppDispatcher, { dispatch } from './dispatcher';

export default Store;
export { AppDispatcher, dispatch, action };
